import React, { useEffect } from "react";
import { App, ConfigProvider, Modal, Table } from "antd";
import { createRoot } from 'react-dom/client';
import { customTheme } from "common/customTheme";
import { EditableContextProvider } from "common/EditableContextProvider";
import { useContacts } from "../Hooks/useContacts";
import ErrorBox from "common/ErrorBox";
import "../../common/style.css";

export default function Main({ cat_user_id }) {
    const context = useContacts(cat_user_id);

    useEffect(() => {
        context.updateToken().then(() => context.fillItems());
    }, []);

    return (
        <div>
            <EditableContextProvider data={{ context }} >
                <Table
                    title={() => (
                        <div className="d-flex justify-content-between">
                            <div className="px-3" style={{ fontSize: '1.25rem' }}>Contactos</div>
                            <button className="btn cat-btn-orange mx-3"
                                onClick={() => context.newItem()}
                            >
                                <i className="fas fa-plus me-2"></i>
                                Añadir Nuevo
                            </button>
                        </div>
                    )}
                    {...context.getTableProps()}
                />
                { context.modalBase.contextModal }
            </EditableContextProvider>
        </div>
    )
}

let main = document.getElementById('contacts-main');

if (main) {
    let cat_user_id = main.dataset.catUserId;

    if(!main.root) { main.root = createRoot(main); }
    main.root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App >
                        <Main cat_user_id={cat_user_id}/>
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
